<template>
  <div class="home-consultant">
    <h3>
      <span class="home-consultant-text">育儿顾问咨询</span>
      <a
        class="show-more"
        href="//life.cekid.com/v/store/workers"
        @click="trackClick(200019, {}, '', 121011908)"
      >
        <span class="home-consultant-more">更多育儿顾问</span>
      </a>
    </h3>
    <div class="cutomRequire-layout">
      <div
        class="cutomRequire"
        :class="{ active: IMData && IMData.businessKey }"
      >
        <button @click="toCustom"></button>
        <!-- <div @click="toIM" v-if="IMData">
                    <p><img :src="IMData.headImage | avatarAdvi(40,40)" ></p><span>{{IMData.workerName}}</span>正在服务
                </div> -->
      </div>
    </div>
    <div class="home-consultant-worker">
      <yuesao :list="list" />
    </div>
  </div>
</template>

<script>
import fetch from '@/plugins/fetch'
import yuesao from './yuesao'
import avatar from '@/assets/images/avatar.png'

const getText = text => val => val ? `${text}${val}\n` : ''

export default {
  PAGE_ID: '288987',
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    },
    citycode: {
      type: [String, Number],
      default: ''
    },
    cityname: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      IMData: {}
    }
  },
  filters: {
    avatar(v) {
      return v ? v : avatar
    }
  },
  computed: {
    uid() {
      return this.$$cookie.get('uid') || ''
    }
  },
  created() {
    // if(this.uid) this.getWorkerIm()
  },
  methods: {
    // async getWorkerIm(){
    //     const resInt = await fetch(`//sccapi.cekid.com/scc-api/fchild/maternity/queryWorkerIntention.do?uid=${this.uid}`);
    //     const resIntJson = await resInt.json();
    //     if(resIntJson && resIntJson.data && resIntJson.data.createTime) { // createTime 有值是在30分钟内没有值在30分钟外,30分钟内去分配育儿顾问
    //         const { cityId, categoryName, districtId, districtName, cityName, maternityDate, mobile,content } = resIntJson.data;
    //         let msgInfo = `您好\n${getText('我的心愿诉求:')(categoryName)}我在${cityName} ${districtName}\n${getText('我的预产期是')(maternityDate)}${getText('联系方式：')(mobile)}${content}`
    //         const msg = {
    //             font: '',
    //             color: '',
    //             message: msgInfo,
    //         }
    //         const res = await this.$store.dispatch('queryWorkerIm',{
    //                 uid:this.uid,
    //                 cityId,
    //                 districtId,
    //                 msg: JSON.stringify(msg),
    //         })
    //         this.IMData = res.data
    //     }
    // },
    toCustom() {
      location.href = `//life.cekid.com/y/servicecustom?swt=1&cid=${this.citycode}&cname=${this.cityname}`
    }
    // toIM(){
    //     const { uid, businessKey } = this.IMData;
    //     if (!this.$$isHZWApp() && !this.$$isRkhy() && uid) {
    //          window.location.href = `https://a.app.qq.com/o/simple.jsp?pkgname=com.kidswant.ss&cmd=usercard&userid=${uid}`//app下载页
    //         return;
    //     }

    //     if (uid && businessKey) {
    //         location.href = `//api.appc.cekid.com/?cmd=imconversation&userid=${uid}&scenetype=11&businesskey=${encodeURIComponent(
    //                 businessKey,
    //             )}&appcode=HZW_MALL`
    //         }
    // }
  },
  components: {
    yuesao
  }
}
</script>

<style lang="scss">
@import '../../assets/css/mixin';
.home-consultant {
  //margin-bottom: rem(30px);
  //padding-bottom: rem(30px);
  background-color: #fff;
  .show-more {
    display: flex;
    align-items: center;
    .icon {
      display: inline-block;
      height: rem(18px);
      width: rem(10px);
      margin: 0 0 rem(2px) rem(10px);
      background: url('//cmspic-10004025.image.myqcloud.com/a887b720-0205-11ea-98a0-c91677e5da3e_size_9x18')
        no-repeat center center;
      background-size: rem(8px) auto;
    }
  }
  h3 {
    padding: rem(30px);
    display: flex;
    align-items: center;
    // background: url('https://hzwimspic-1251601690.picsh.myqcloud.com/d6562450-4edd-11ea-a8d7-a9d7fb9b08b4_size_1053x92') no-repeat;
    //background-size: 100% 33px;
    .home-consultant-text {
      flex: 1;
      font-size: rem(36px);
      font-weight: 600;
      color: #000;
    }
    a {
    }
    .home-consultant-more {
      font-size: rem(24px);
      color: #999;
    }
    // .iconfont{
    //     display: inline-block;
    //     color:#666;
    //     font-size: rem(24px);
    //     transform: rotate(-90deg);
    // }
  }

  .home-consultant-activity {
    padding: rem(40px) rem(20px) 0 rem(20px);

    li {
      padding-bottom: rem(30px);
    }
    a {
      display: flex;
    }
    img {
      width: rem(250px);
      height: rem(150px);
      object-fit: cover;
    }
    .home-consultant-activity-content {
      flex: 1;
      padding-left: rem(20px);
    }
    .home-consultant-activity-title {
      font-size: rem(30px);
      color: #121212;
      font-weight: 700;
    }
    .home-consultant-activity-text {
      padding-top: rem(21px);
      font-size: rem(24px);
      color: #999999;
    }
  }
}
.cutomRequire-layout {
  padding: 0 rem(30px);
  padding-bottom: rem(18px);
}
.cutomRequire {
  display: flex;
  width: 100%;
  height: rem(178px);
  background: url('~@/assets/images/yegwxq_ct@3x.png') no-repeat left top;
  background-size: 100% rem(178px);
  flex-direction: column;
  align-items: flex-end;
  button {
    width: rem(188px);
    height: rem(54px);
    margin: rem(62px) 0;
  }
  > div {
    height: 0;
    overflow: hidden;
    width: 100%;
  }
  &.active {
    height: rem(254px);
    background: url('~@/assets/images/yegwxq_ct_ing@3x.png') no-repeat left top;
    background-size: 100% rem(254px);
    > div {
      height: rem(76px);
      display: flex;
      align-items: center;
      padding: 0 rem(24px);
      font-size: rem(26px);
      line-height: rem(32px);
      color: #4d4d4d;
      p {
        width: 20px;
        height: 20px;
        border-radius: 100%;
        overflow: hidden;
        @include border(all, #ff397e, 1px, 100%);
        font-size: 0;
      }
      img {
        width: 100%;
        height: 100%;
        overflow: hidden;
        object-fit: cover;
      }
      span {
        padding-left: rem(12px);
        padding-right: rem(8px);
        color: #000000;
      }
    }
  }
}
.home-consultant-worker {
  padding: 0 rem(30px);
  padding-bottom: rem(20px);
}
</style>
